import {
    SAVE_ID_PHOTO,
    RESET_ID_PHOTO
} from './actions';

export const initialState = {
    idPhoto: '',
};

const selfieReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ID_PHOTO:
            return {
                ...state,
                idPhoto: action.idPhoto
            }
        case RESET_ID_PHOTO:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default selfieReducer;